import { LucideIcon } from 'lucide-react';

interface MetricCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export default function MetricCard({ icon: Icon, title, description }: MetricCardProps) {
  return (
    <div
      className="
        bg-white
        border-2 border-gray-200
        rounded-2xl
        p-8
        transition-all duration-300
        hover:border-cyan-500
        hover:shadow-xl hover:shadow-cyan-500/10
        hover:-translate-y-1
      "
    >
      <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center mb-6 shadow-lg shadow-cyan-500/30">
        <Icon className="w-7 h-7 text-white" strokeWidth={2} />
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
  );
}
